var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 8.33334C21.75 14.1667 15 19.1667 15 19.1667C15 19.1667 8.25 14.1667 8.25 8.33334C8.25 4.19121 11.2721 0.833344 15 0.833344C18.7279 0.833344 21.75 4.19121 21.75 8.33334Z",
    stroke: "white",
    strokeWidth: 1.46342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8333C16.2426 10.8333 17.25 9.71406 17.25 8.33334C17.25 6.95263 16.2426 5.83334 15 5.83334C13.7574 5.83334 12.75 6.95263 12.75 8.33334C12.75 9.71406 13.7574 10.8333 15 10.8333Z",
    stroke: "white",
    strokeWidth: 1.46342,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21951 13V15.6341C3.73841 16.5233 2.19512 17.7252 2.19512 18.8723C2.19512 21.0771 7.89649 23.4843 15 23.4843C22.1035 23.4843 27.8049 21.0771 27.8049 18.8723C27.8049 17.7252 26.2616 16.5233 23.7805 15.6341V13C27.5428 14.2288 30 16.2902 30 18.8723C30 23.1512 23.2527 26 15 26C6.7473 26 0 23.1512 0 18.8723C0 16.2902 2.45716 14.2288 6.21951 13Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTracker);
export default __webpack_public_path__ + "static/media/map_tracker.5ad023305e11354fcd6677ae27d57c19.svg";
export { ForwardRef as ReactComponent };